import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import translations
import translationDE from '../../locales/de/translation.json';
import translationEN from '../../locales/en/translation.json';
import translationFR from '../../locales/fr/translation.json';


// Define resources with translations
const resources = {
  de: {
    translation: translationDE
  },
  fr: {
    translation: translationFR
  },
  en: {
    translation: translationEN
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    lng: 'de',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Disable automatic language detection
      order: [],
      caches: [],
    }
  });

export default i18n; 